import { useCallback } from "react";
import { ListingURLParamType } from "../utils";

/**
 * Removes all query parameters
 */
export const useRemoveAllQueryParams = () => {
  return useCallback(() => {
    const url = new URL(window.location.href);
    const baseOrigin = url.origin;
    const existingParams = new URLSearchParams(url.search);
    const exceptionsTerms: Array<string> = [
      ListingURLParamType.SORT,
      ListingURLParamType.TEXT,
    ];

    const deleteKeys: Array<string> = [];
    existingParams.forEach((_, key) => {
      if (!exceptionsTerms.includes(key)) {
        deleteKeys.push(key);
      }
    });

    deleteKeys.forEach((key) => {
      existingParams.delete(key);
    });

    const new_params = existingParams ? `?${existingParams.toString()}` : "";

    return `${baseOrigin}${url.pathname}${new_params}`;
  }, []);
};

export default useRemoveAllQueryParams;
